import script from "./AbstractsOpen.vue?vue&type=script&setup=true&lang=js"
export * from "./AbstractsOpen.vue?vue&type=script&setup=true&lang=js"

import "./AbstractsOpen.vue?vue&type=style&index=0&id=ee10a3c8&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee10a3c8"]])

export default __exports__